import type { FragmentType } from '@/gql/codegen';
import { useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { useSidebar } from '@/routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout';
import { useNavigate } from '@tanstack/react-router';

import type React from 'react';
import { useEffect, useState } from 'react';

import { SkillCheckTestResultPage } from '../-Page';

export const USER_SKILL_CHECK_TEST_RESULT_CONTAINER = graphql(/* GraphQL */ `
  fragment EmbaUserSkillCheckTestResultContainer on UserSkillCheckTestResult {
    firstCleared
    ...EmbaUserSkillCheckTestResult
  }
`);

export type SkillCheckTestResultContainerProps = {
  embaUserSkillCheckTestResult: FragmentType<
    typeof USER_SKILL_CHECK_TEST_RESULT_CONTAINER
  >;
  userAttendanceSlug: string;
  timeUp?: boolean;
  isAnswered?: boolean;
};

export const SkillCheckTestResultContainer = ({
  embaUserSkillCheckTestResult,
  userAttendanceSlug,
  timeUp,
  isAnswered,
}: SkillCheckTestResultContainerProps) => {
  const { showSidebar } = useSidebar();
  const navigate = useNavigate();
  const embaUserSkillCheckTestResultData = useFragment(
    USER_SKILL_CHECK_TEST_RESULT_CONTAINER,
    embaUserSkillCheckTestResult,
  );
  const [isTimeUpModalOpen, setIsTimeUpModalOpen] = useState(timeUp ?? false);
  const [isFirstClearedModalOpen, setFirstClearedModalOpen] = useState(
    !!isAnswered && embaUserSkillCheckTestResultData.firstCleared,
  );

  const navigateToSkillCheckTest = () => {
    navigate({
      to: '/user-attendances/$userAttendanceSlug/skill-check-test',
      params: {
        userAttendanceSlug,
      },
      search: {
        retry: true,
      },
    });
  };

  const closeTimeUpModal = () => {
    setIsTimeUpModalOpen(false);
  };

  const closeFirstClearedModal = () => {
    setFirstClearedModalOpen(false);
  };

  useEffect(() => {
    showSidebar();
  }, [showSidebar]);

  return (
    <SkillCheckTestResultPage
      embaUserSkillCheckTestResult={embaUserSkillCheckTestResultData}
      navigateToSkillCheckTest={navigateToSkillCheckTest}
      isTimeUpModalOpen={isTimeUpModalOpen}
      closeTimeUpModal={closeTimeUpModal}
      isFirstClearedModalOpen={isFirstClearedModalOpen}
      closeFirstClearedModal={closeFirstClearedModal}
    />
  );
};
